import { usePostcodeSearch } from '@hooks';
import { Select, Spin } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

const { Option } = Select;

interface IProps {
  value?: string;
  disabled?: boolean;
  onSelect: (value: string) => void;
}

export const PostcodeSelect: React.FC<IProps> = observer(({ onSelect, value, disabled }) => {
  const { postcodes, loading, onSearch, clearPostcodes } = usePostcodeSearch();

  return (
    <Select
      showSearch
      allowClear
      disabled={disabled}
      placeholder="Enter postcode"
      notFoundContent={loading ? <Spin size="small" /> : null}
      filterOption={false}
      value={value || undefined}
      onSearch={onSearch}
      onSelect={onSelect}
      onClear={clearPostcodes}
      style={{ width: '100%' }}
    >
      {postcodes?.filter((pc) => pc != null).map((pc) => (
        <Option key={pc} value={pc}>
          {pc}
        </Option>
      ))}
    </Select>
  );
});
